(function () {
  function containerUpdate(container, cardSize) {
    let timeoutId;
    container.setAttribute("data-productis-in-row", cardSize);

    container.setAttribute("data-switching", true);
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      container.removeAttribute("data-switching");
    }, 300);
  }

  function switchCardSize() {
    const buttons = document.querySelectorAll(".per-row__button");
    const pageHeader = document.querySelector("sticky-header.header-wrapper");
    let headerRevealTimeout = null;
    let currentAbortController = null;
    const handleButtonEvent = (button) => {
      const cardSize = button.dataset.perRow;

      buttons.forEach((btn) => {
        btn.classList.remove("active");
        btn.setAttribute("aria-pressed", "false");
      });
      button.classList.add("active");
      button.setAttribute("aria-pressed", "true");

      document.querySelectorAll("[data-productis-in-row]").forEach((el) => {
        containerUpdate(el, cardSize);
      });

      if (pageHeader) {
        if (headerRevealTimeout) clearTimeout(headerRevealTimeout);
        pageHeader.preventReveal = true;
      }

      if (currentAbortController) currentAbortController.abort();
      currentAbortController = new AbortController();

      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            "catalog-card-size": cardSize,
          },
        }),
        signal: currentAbortController.signal,
      })
        .then((response) => {
          if (response.ok) {
            console.info(`Catalog card size "${cardSize}" saved successfully.`);
          }
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.error("Request error:", error);
          }
        })
        .finally(() => {
          if (pageHeader) {
            headerRevealTimeout = setTimeout(() => {
              pageHeader.preventReveal = false;
            }, 400);
          }
        });
    };
    buttons.forEach((button) => {
      const isActivatedButton =
        button.dataset.perRow ==
        document
          .getElementById("ProductGridContainer")
          .getAttribute("data-productis-in-row");
      button.classList[isActivatedButton ? "add" : "remove"]("active");
      button.setAttribute("aria-pressed", isActivatedButton ? "true" : "false");
      button.addEventListener("click", () => handleButtonEvent(button));
      button.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") handleButtonEvent(button);
      });
    });
  }

  switchCardSize();

  document.addEventListener("shopify:section:load", function () {
    switchCardSize();
  });
})();
